import { lang } from '@umu/ukit-lang';
import React from 'react';

import { components } from 'common';
const { If, PreImg } = components;
import { IProfileInfo } from '@umu/umu-types';
import { getProfileIndexUrl as getIndexUrl } from '@umu/umu-util';
import { QrGenerator } from '../../../qrCode';

import './columnCard.scss';

import logo from 'common/src/images/logo.png';
import defaultAvatar from '../../../../images/defaultAvatar.png';

interface IProps {
    isEnterprise: boolean;
    profileInfo: IProfileInfo;
}
export const ColumnCard = ({ profileInfo, isEnterprise }: IProps) => {
    const shareUrl = getIndexUrl(profileInfo.profile_id);
    const likeNum = profileInfo.likes_count;
    const followedNum = profileInfo.followed_count;
    return (
        <div className={`column-card ${isEnterprise ? '' : 'has-logo'}`}>
            <div className="bg-yellow" />
            <PreImg>
                <img src={profileInfo.avatar || defaultAvatar} className="avatar" />
            </PreImg>
            <div className="name umu-text-clamp clamp-1">{(profileInfo.user_name || '').trim()}</div>
            <If condition={profileInfo.affected_student_count > 0}>
                <div className="influence">
                    {lang('影响的学员')}
                    <span className="num">{profileInfo.affected_student_count}</span>
                </div>
            </If>
            <If condition={followedNum > 0 || likeNum > 0}>
                <div className={`follow-like ${followedNum > 0 && likeNum > 0 ? 'has-all' : ''}`}>
                    <If condition={followedNum > 0}>
                        <div className="follow">
                            {lang('关注ta的人')}
                            <span className="num">{followedNum}</span>
                        </div>
                    </If>
                    <If condition={followedNum > 0 && likeNum > 0}>
                        <div className="split" />
                    </If>
                    <If condition={likeNum > 0}>
                        <div className="like">
                            {lang('获得点赞')}
                            <span className="num">{likeNum}</span>
                        </div>
                    </If>
                </div>
            </If>
            <div className="share-qr-code">
                <QrGenerator url={shareUrl} />
                {lang('扫描二维码来UMU关注我')}
            </div>
            <If condition={!isEnterprise}>
                <PreImg>
                    <img src={logo} className="logo" />
                </PreImg>
            </If>
        </div>
    );
};
